<h6 class="text" *ngIf="serviceBuyer" (click)="selectBuyer()">
  Logged in as Service Operator for
  <b>{{ serviceBuyer.name }}</b>
  Account
  <i class="fa fa-caret-down ms-1"></i>
</h6>
